<template>
  <!-- <div class="manage-position-title title-tab">
    จัดการอนุมัติบริษัท
  </div> -->
  <div class="header-title header-title-text title-notab">
    <v-row>
      <v-col cols="" class="ma-5">
        จัดการโทเคนภายนอก
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="2" class="pt-0 pb-0 d-flex align-center justify-end mt-1 ml-2 mr-5">
        <v-btn
          class="button-color head-search-button"
          elevation="0"
          dark
          @click="gotocreate()"
        >
          <v-icon left size="14px">
            mdi-pencil-outline
          </v-icon>
          ร้องขอการใช้บริการ
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
export default {
  data () {
    return {
      tabName: 0,
      companyTitleName: '',
      companyUID: '',
      companyNameTitle: '',
      checkBtnRegister: false
    }
  },
  beforeDestroy () {
    EventBus.$off('tabstitletructure')
    EventBus.$off('checkBtnRegister')
  },
  mounted () {
    EventBus.$on('tabstitletructure', this.getDataTab)
    EventBus.$on('checkBtnRegister', this.checkRegister)
  },
  created () {
    this.tokenUser = this.$store.state.token
    this.propsitems = this.$route.params.id
    this.companyUID = this.propsitems
    this.companyNameTitle = this.$route.params.company
  },
  methods: {
    checkRegister (value) {
      this.checkBtnRegister = value
    },
    editData (item) {
      // this.$router.push('managestructure/update/601287bd0b1f0b12d889b914')
      this.$router.push('/managestructure/update/' + item)
    },
    goBack () {
      // console.log('back 2')
      // this.$router.push('managestructure')
      this.$router.push({
        name: 'ManageStructureOverview'
      })
    },
    getDataTab (val) {
      this.tabName = String(val)
    },
    gotocreate () {
      this.$router.push('manageapprovetoken/create')
    }
  }
}
</script>

<style>
.manage-department-title {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1.5rem;
}
.ra-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-button-upload {
  /* position: absolute; */
  /* height: 72px;
  left: 0px;
  right: 0px;
  top: 0px; */

  /* Color/Other/Background */

  background: #F8F9FA;
}
</style>
